module.exports = __webpack_public_path__ + "img/what-we-do-bg.b478d912.png";